/**
 * atonce/work-areas — stan kafla jak w makiecie online (komponent Bh): najechanie → `data-stan="gra"` (ruch wejścia 420 ms),
 * zjechanie → `wyjscie` (dolary i logotyp wychodzą górą 200 ms), po 200 ms `spoczynek`. Bez myszy (dotyk) CSS gra w pętli, bez ruchu — klatka końcowa.
 */
( () => {
	const OUT = 200;
	document.querySelectorAll( '.wka__item' ).forEach( ( li ) => {
		let t = null;
		li.addEventListener( 'pointerenter', () => { if ( t ) { clearTimeout( t ); t = null; } li.dataset.stan = 'gra'; } );
		li.addEventListener( 'pointerleave', () => { li.dataset.stan = 'wyjscie'; if ( t ) { clearTimeout( t ); } t = setTimeout( () => { li.dataset.stan = 'spoczynek'; t = null; }, OUT ); } );
	} );
} )();
